import React from "react";
import history from "../../../history/history";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions/allActions";
import { Loading } from "../../../components/utils/Loading";
import ParticipantFormHeader from "./ParticipantFormHeader";
import * as pState from "../../../reducers/participantReducer";
import ParticipantFormInput from "./ParticipantFormInput";

export const ParticipantForm: React.FC = () => {
  const { values, inputs, uuid, initLoading, eventId } = useSelector(
    pState.selectParticipantDetailsFormData
  );
  const dispatch = useDispatch();

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    array: boolean
  ) => {
    dispatch(
      allActions.participantActions.changeParticipantsData(
        e.target.id,
        e.target.value,
        array
      )
    );
  };

  const saveChanges = () => {
    dispatch(
      allActions.participantActions.saveParticipantChanges(uuid, eventId)
    );
  };

  const goback = () => {
    history.goBack();
  };

  return (
    <div className='container w-screen h-11/12'>
      <div className='flex flex-col h-full w-full'>
        <ParticipantFormHeader goback={goback} save={saveChanges} />
        {initLoading ? (
          <Loading styles={"items-center my-auto"} />
        ) : (
          <div className='flex-1 w-full h-full mx-auto rounded shadow-xl border border-gray-200 overflow-y-auto overflow-x-hidden scroller'>
            <table className='table-fixed'>
              <tbody>
                {inputs.map((input) => {
                  const key =
                    input.question.trim().length === 0
                      ? input.id
                      : input.question;
                  return (
                    <tr key={input.id} className='table-row'>
                      <td className='w-1/3 my-2 py-4 pl-8 uppercase border border-gray-200 text-brand-dark_blue'>
                        {key}
                      </td>
                      <td className='w-2/3 h-full border border-gray-200 '>
                        <ParticipantFormInput
                          styles='box-border py-4 pl-6 h-full w-full truncate relative'
                          value={values[input.id] || ""}
                          item={input}
                          handleInputChange={handleInputChange}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParticipantForm;
